import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { supabaseAdmin } from "@/integrations/supabase/client.server";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";

const inputSchema = z.object({
  message: z.string().min(1).max(2000),
  stack: z.string().max(8000).optional().nullable(),
  route: z.string().max(500).optional().nullable(),
  user_agent: z.string().max(500).optional().nullable(),
});

/**
 * Log a client-side unexpected error to error_logs.
 * Requires authentication. user_id is taken from the authenticated session,
 * NOT from client input (prevents log poisoning / impersonation).
 * Best-effort; never throws to the caller.
 */
export const logClientError = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .inputValidator((data: unknown) => inputSchema.parse(data))
  .handler(async ({ data, context }) => {
    try {
      const { error } = await supabaseAdmin.from("error_logs").insert({
        message: data.message,
        stack: data.stack ?? null,
        route: data.route ?? null,
        user_agent: data.user_agent ?? null,
        user_id: context.userId,
      });
      if (error) {
        console.error("[error_logs] insert failed:", error.message);
        return { ok: false as const };
      }
      return { ok: true as const };
    } catch (e) {
      console.error("[error_logs] handler exception:", e);
      return { ok: false as const };
    }
  });
